module.exports = __webpack_public_path__ + "img/collection-diamondJewelrySignet@2x.d98a2f0.jpg";